import { useState, useEffect } from 'react'
import { getTeamsExpandAPI } from '../../services/teams'

function UseTeamsExpand(orgId, divisionId, departmentId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      dsId: divisionId,
      dmId: departmentId,
      searchs
    }
    const getData = async () => {
      const result = await getTeamsExpandAPI(param)
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d, i) => {
          return {
            value: d?.team_id,
            label: d?.team,
            data: d?.team
          }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    if (orgId > 0 && divisionId) {
      getData()
    }
  }, [orgId, divisionId, departmentId])

  return data
}

export default UseTeamsExpand
